import React from 'react';
import styled from 'styled-components';
import {orderBy} from 'lodash';
import uuidv4 from 'uuid/v4';
import {currentResource} from '../../../util/utils';
import AssignmentsItem from './AssignmentsItem';

function AssignmentsList({taskAssignments, dueDate, taskTypeId, engagementId, taskId, taskStatusId}) {
	const reviewerAssignmentLabels = currentResource.reviewerAssignments;
	return (
		<React.Fragment>
			<StyledAssignmentList>
				<li className="assignmentListWrapper">
					<section className="assignmentHeading">{reviewerAssignmentLabels.assignmentTableColumnHeader}</section>
					<section className="teamMemberHeading">{reviewerAssignmentLabels.teamMemberTableColumnHeader}</section>
					<section className="dueHeading">{reviewerAssignmentLabels.dueDaysTableColumnHeader}</section>
				</li>
				{orderBy(taskAssignments, ['dueDays'], ['desc']).map((a, index) => {
					return (
						<li className="assignmentListDataWrapper" key={uuidv4()}>
							<AssignmentsItem
								{...a}
								dueDate={dueDate}
								taskTypeId={taskTypeId}
								taskStatusId={taskStatusId}
								engagementId={engagementId}
								taskId={taskId}
							/>
						</li>
					);
				})}
			</StyledAssignmentList>
		</React.Fragment>
	);
}

export default AssignmentsList;
const StyledAssignmentList = styled.ul`
	.assignmentListWrapper {
		padding: var(--px-12) var(--px-40) var(--px-12) var(--px-16);
		background: var(--neutrals-25);
		display: flex;
		.assignmentHeading {
			display: flex;
			max-width: var(--px-230);
			font-weight: 400;
			font-size: var(--px-14);
			color: var(--neutrals-900);
			flex-grow: 1;
			line-height: var(--px-20);
		}
		.teamMemberHeading {
			display: flex;
			max-width: var(--px-180);
			font-weight: 400;
			font-size: var(--px-14);
			color: var(--neutrals-900);
			flex-grow: 1;
			line-height: var(--px-20);
		}
		.dueHeading {
			display: flex;
			max-width: var(--px-180);
			font-weight: 400;
			font-size: var(--px-14);
			color: var(--neutrals-900);
			flex-grow: 1;
			line-height: var(--px-20);
		}
	}
	.assignmentListDataWrapper {
		display: flex;
		position: relative;
		.assignmentTextWrapper {
			display: flex;
			max-width: var(--px-230);
			padding: var(--px-5) var(--px-16);
			align-items: center;
			flex-grow: 1;

			.reviewerAssignmentWrapper {
				display: flex;
				flex-direction: column;
				margin-left: var(--px-10);
				max-width: calc(100% - var(--px-40));
				.reviewerAssignment {
					font-size: var(--px-12);
					font-weight: 400;
					line-height: var(--px-18);
					color: var(--neutrals-900);
				}
				.assignmentNameText {
					font-size: var(--px-14);
					font-weight: 300;
					line-height: var(--px-20);
					color: var(--neutrals-900);
					.StyledEllipseDiv {
						font-size: var(--px-14);
						font-weight: 300;
						line-height: var(--px-20);
						color: var(--neutrals-900);
					}
				}
			}
		}
		.teamMemberText {
			display: flex;
			max-width: var(--px-180);
			padding: var(--px-5) 0;
			font-weight: 300;
			font-size: var(--px-14);
			color: var(--neutrals-900);
			align-items: center;
			flex-grow: 1;
			line-height: var(--px-20);
		}
		.dueText {
			display: flex;
			max-width: var(--px-180);
			padding: var(--px-5) 0;
			flex-direction: column;
			line-height: normal;
			flex-grow: 1;
			.dueDateText {
				font-weight: 400;
				font-size: var(--px-12);
				color: var(--neutrals-900);
				line-height: var(--px-18);
			}
			.dueDateValue {
				font-weight: 300;
				font-size: var(--px-14);
				color: var(--neutrals-900);
				margin-top: var(--px-5);
				line-height: var(--px-20);
			}
		}
		.assignment-status-btn {
			height: var(--px-22);
			width: var(--px-22);
			margin-right: var(--px-10);
			border: none;
			background: transparent;
			svg {
				fill: var(--green-400);
				&.complete-check {
					fill: var(--neutrals-700);
				}
			}
			&.noActionBtn {
				svg {
					cursor: default;
				}
			}
			&[disabled] {
				svg {
					fill: var(--neutrals-300);
				}
			}
		}
	}
`;
